import React from 'react'
import { Label } from '~/lib/ui/label'
import { cn } from '~/lib/utils'

const OnboardingFormLabel = ({ className, children, ...props }) => {
  return (
    <Label
      {...props}
      className={cn('subtitle gap mb-2 flex flex-col leading-[1.3]', className)}
    >
      {children}
    </Label>
  )
}

export default OnboardingFormLabel
